import { Injectable } from '@angular/core';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { EventGTM } from '../providers/services/tag-manager/models/tag-manager.models';

@Injectable()
export abstract class TagManagerService {

  abstract logError(paso: string, errorMessage: string, desc: string);
  abstract logAgregarProducto(option: string);
  abstract logDL_datosPersonales();
  abstract logDL_datosSocios();
  abstract logDL_completa_datos();
  abstract logDL_inicioActividades(actEconomic: boolean);
  abstract logDL_adjuntarDocumentos();
  abstract logDL_cuentaAbono(esCuentaPropia: boolean);
  abstract logDL_cofiguracionProducto(producto: Product, configProductos: any);
  abstract logEliminarProducto(product: Product);
  abstract logDiaEntrega();
  abstract logCuotas();
  abstract logEditaCuentaAbono();
  abstract logPagarOrden();
  abstract logCierre(idSS: string);
  abstract logPaso3(dataPaso3: Paso3, tipoPersona: boolean);
  abstract logResumenPago(dataPaso3: Paso3, tipoPersona: boolean);
  abstract logEvent(event:EventGTM ):void;

}
